import RestaurantMenu from './RestaurantMenu';

export default RestaurantMenu;
